module.exports = __webpack_public_path__ + "static/img/Andrew_Gaff_mobile.2f3b51a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Andrew_Gaff_mobile.jpg
// module id = ZRWA
// module chunks = 0